// src/pages/Events.js
import React from 'react';
import './events.css'; // Import CSS for styling

const eventsData = {
  
  April: [
    { title: 'സഖ്യം ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്', date: ' ', description: 'സഖ്യം ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്' },

  ],
  May: [
    { title: 'സഖ്യം ഭാരവാഹികളുടെ സത്യപ്രതിജ്ഞയും നയപ്രഖ്യാപനവും', date: ' ', description: 'സഖ്യം ഭാരവാഹികളുടെ സത്യപ്രതിജ്ഞയും നയപ്രഖ്യാപനവും' },
    { title: ' സഖ്യം ജന്മദിനാഘോഷം ', date: 'മേയ് 29', description: ' സഖ്യം ജന്മദിനാഘോഷം' },
    { title: ' സംസ്ഥാന സിവിൽ സർവീസ് ക്യാംപ് ', date: '', description: ' സംസ്ഥാന സിവിൽ സർവീസ് ക്യാംപ്' },
    { title: ' സഖ്യം വെബ്ൈസറ്റ് ഉദ്ഘാടനം ', date: 'മേയ് 29', description: ' സഖ്യം വെബ്ൈസറ്റ് ഉദ്ഘാടനം' },

  ],
  June: [
    { title: 'പരിസ്ഥിതി ദിനാഘോഷം ', date: ' ജൂൺ 5', description: 'പരിസ്ഥിതിദിനാഘോഷം' },
    { title: 'രക്ഷാധികാരിമാരുടെ സംസ്ഥാന സമ്മേളനം', date: '', description: 'രക്ഷാധികാരിമാരുടെ സംസ്ഥാന സമ്മേളനം' },
    { title: ' അംഗത്വ വിതരണം ', date: '', description: ' അംഗത്വ വിതരണം' },
  ],
  July: [
    { title: 'നേതൃത്വപരിശീലനം ക്യാംപ്', date: ' ', description: 'നേതൃത്വപരിശീലനം ക്യാംപ്' },
    { title: ' ലഹരിവിരുദ്ധ പരിപാടികൾ', date: ' ', description: ' ലഹരിവിരുദ്ധ പരിപാടികൾ' },
  ],
  August: [
    { title: 'യൂണിയനുകളിൽ സർഗോത്സവം', date: ' ', description: 'യൂണിയനുകളിൽ സർഗോത്സവം' },
  ],
  September: [
    { title: ' ലഹരിവിരുദ്ധ പരിപാടികൾ', date: ' ', description: 'ശാഖകളിലും യൂണിയനുകളിലും ലഹരിവിരുദ്ധ ബോധവൽക്കരണ പരിപാടികൾ തുടരുന്നു' },
    { title: 'മേഖലാ സർഗോത്സവം', date: '', description: 'മേഖലാ സർഗോത്സവം' },
  ],
  October: [
    { title: ' സേവനമാസ ആഘോഷം', date: ' ', description: 'ശാഖകളും യൂണിയനുകളും മേഖലകളും േസവന മാസമായി ആഘോഷിക്കുന്നു. We serve എന്ന നമ്മുടെ മുദ്രാവാക്യം യാഥാർഥ്യമാക്കുവാനും പുതു തലമുറയിൽ സമൂഹത്തോടുള്ള പ്രതിബദ്ധത വളർത്തുവാനും സഹായകരമായ പരിപാടികൾ ' },
  ],
  November: [
    { title: 'പ്രകൃതിപഠന സംസ്ഥാന ക്യാംപ്', date: ' ', description: 'പ്രകൃതിപഠന സംസ്ഥാന ക്യാംപ്' },
    { title: 'ഹോർത്തൂസ്', date: '', description: 'ഹോർത്തൂസ്' },
    { title: ' യൂണിയനുകളിലും മേഖലകളിലും പ്രസംഗമത്സരങ്ങൾ ', date: '', description: ' യൂണിയനുകളിലും മേഖലകളിലും പ്രസംഗമത്സരങ്ങൾ' },
    { title: ' യൂണിയനുകളിലും മേഖലകളിലും ക്വിസ് മത്സരങ്ങൾ ', date: '', description: ' യൂണിയനുകളിലും മേഖലകളിലും ക്വിസ് മത്സരങ്ങൾ' },
  ],
  December: [
    { title: 'മേഖല ക്യാംപുകൾ', date: ' ', description: 'മേഖല ക്യാംപുകൾ' },
  ],
  January: [
    { title: 'പരീക്ഷാ മാർഗനിർദേശ ക്ലാസുകൾ', date: '', description: 'പരീക്ഷാ മാർഗനിർദേശ ക്ലാസുകൾ' },
    { title: 'സഖ്യം സംസ്ഥാന പ്രസംഗമത്സരം', date: '', description: 'സഖ്യം സംസ്ഥാന പ്രസംഗമത്സരം' },
  ],
  February: [
    { title: 'സഖ്യം ശാഖായൂണിയൻ ഭാരവാഹി തിരഞ്ഞെടുപ്പ്', date: ' ', description: 'സഖ്യം ശാഖായൂണിയൻ ഭാരവാഹി തിരഞ്ഞെടുപ്പ്' },
  ],
  March: [
    { title: 'മേഖലാ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്', date: 'March 10 ', description: 'മേഖലാ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്' },
  ],
  // Add more months and events as needed
};

function Events() {
    return (
      <div className="calendar-container">
        <h1 className="calendar-title">📅 EVENTS CALENDAR 2025-2026</h1>
        <div className="calendar-grid">
          {Object.entries(eventsData).map(([month, events]) => (
            <div key={month} className="calendar-month">
              <h2 className="month-title">{month}</h2>
              <ul className="month-events">
                {events.map((event, index) => (
                  <li key={index} className="calendar-event">
                    <h3 className="event-title">{event.title}</h3>
                    <div className="event-details">
                      {event.date && <p><strong>📌 {event.date}</strong></p>}
                      <p>{event.description}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    );
  }
  
  export default Events;
